import React from 'react'
import { Field } from 'react-final-form'
import { FieldRenderProps } from 'react-final-form'

import { DamageItem, ValuationResponse } from '../../types'
import DamageFormComponent from './components/damage-form.component'
import DamageTableComponent from './components/damage-table.component'

interface DamageProps extends FieldRenderProps {
  valuation: ValuationResponse
}

const DamageComponent: React.FC<DamageProps> = ({ valuation, input: { value, onChange } }) => {
  const removeDamage = (index: number) => {
    const newArr = [...value]
    newArr.splice(index, 1)
    onChange(newArr)
  }

  /**
   * This method enriches the data returned from the damage form with the valuation/quote details and adds it to the valuation field value
   */
  const addDamage = (pendingDamage: DamageItem | any) => {
    // here we just append it to the bottom of the array
    const newDamages = [
      ...value,
      {
        ...pendingDamage,
        valuationId: valuation.valuationId,
        valuationGuid: valuation.valuationGuid,
        quoteId: valuation.quoteId,
        quoteGuid: valuation.quoteGuid,
        lastUpdated: new Date().toISOString(),
      },
    ]
    onChange(newDamages)
  }

  return (
    <>
      <DamageFormComponent onAddDamage={addDamage} />
      <DamageTableComponent damages={value} onRemoveDamage={removeDamage} />
    </>
  )
}

const FormField = (props: any) => (
  <Field name="damages" subscription={{ value: true }} component={DamageComponent} {...props} />
)

export default FormField
